const appendDownloadLink = (href, fileName) => {
  const link = window.document.createElement('a');
  link.href = href;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadBlob = (blob, fileName) => {
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, fileName);
    return;
  }

  const href = window.URL.createObjectURL(blob, { type: 'text/plain' });
  appendDownloadLink(href, fileName);
  window.URL.revokeObjectURL(href);
};

/** Downloads a file returned by the API as { fileName, contentType, base64 }. */
export const downloadBase64File = ({ fileName, contentType, base64 }) => {
  const bytes = Uint8Array.from(window.atob(base64), char => char.charCodeAt(0));
  downloadBlob(new Blob([bytes], { type: contentType }), fileName);
};
